"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Aperture = function Aperture() {
  return _react2.default.createElement(
    "g",
    { id: "aperture" },
    _react2.default.createElement("path", {
      d: "M185,212.5 L305,5 C287.5,2.5 267.5,0 250,0 C190,0 135,20 92.5,57.5 L185,215 L185,212.5 Z M487.5,175 C465,102.5 410,42.5 337.5,17.5 L247.5,175 L487.5,175 Z M495,200 L307.5,200 L315,212.5 L435,420 C475,375 500,315 500,250 C500,232.5 497.5,215 495,200 Z M162.5,250 L65,80 C25,125 0,185 0,250 C0,267.5 2.5,285 5,300 L192.5,300 L162.5,250 Z M12.5,325 C35,397.5 90,457.5 162.5,482.5 L255,325 L12.5,325 Z M292.5,325 L195,495 C212.5,500 230,500 250,500 C310,500 365,480 407.5,442.5 L315,285 L292.5,325 Z"
    })
  );
};

exports.default = Aperture;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Aperture.js
// module id = 2919
// module chunks = 4